import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationBox } from '../../core/ui/notification-box/notification-box';
import { AccountService } from '../../services/account-service';
import { TextboxModule } from '../../../../../../libs/Shared/components/inputs/textbox/textbox.module';
import { environment } from '../../../environments/environment';

type PromoSlide = {
  src: string;
  title: string;
  description: string;
};

@Component({
  selector: 'app-sign-in-page',
  imports: [FormsModule, CommonModule, NotificationBox, TextboxModule],
  templateUrl: './sign-in-page.html',
})
export class SignInPage implements OnInit, OnDestroy {


  @ViewChild('notificationBox') notificationBox!: NotificationBox;
  readonly auditAccountSetupUrl = `${environment.auditUrl}/manage/account-setup`;
  
  email: string = '';
  password: string = '';
  twoFactorCode: string = '';
  userId: string = '';
  uiError: string = '';
  errorPop: boolean = false;
  errorAnimation: string = '';

  // page modes
  pageMode: string = 'signIn';

  slides: PromoSlide[] = [
    {
      src: 'assets/img/promo-1.png',
      title: 'CPO Portal: Payments in one place',
      description:
        'Run your day-to-day payment operations from a single suite. Less tab-switching, clearer status.',
    },
    {
      src: 'assets/img/promo-2.png',
      title: 'CPO Audit: Built for your team',
      description:
        'Give your finance team the tools they need to make smart decisions.',
    },
  ];
  activeIndex = 0;

  private promoIntervalId: ReturnType<typeof setInterval> | undefined;
  
  //require2FA = false;
  //resetPassword = false;


  constructor(
    private readonly router: Router, 
    private readonly accountService: AccountService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    console.log("Referrer: ", document.referrer);
    // TO DO: if the user is already logged in, redirect to the appropriate page
    // ...

    this.promoIntervalId = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
    }, 3000);
  }

  ngOnDestroy() {
    if (this.promoIntervalId !== undefined) {
      clearInterval(this.promoIntervalId);
    }
  }
  
  async btnGoogleLogin_click() {

    const response = await this.accountService.googleLogin().catch(error => {
      this.notificationBox.showMessage("Error logging in. Please try again later: " + error.message);
      return error;
    });

    if (!response) {
      return;
    } 
    else if (response.requires2FA) {
      //this.require2FA = true;
      this.pageMode = 'require2FA';
      this.userId = response.userId;

      // For some reason the Google stuff is not playing nice with the local change detection
      this.cdr.detectChanges();
    } 
    else {
      this.returnUserToApp(response);
    }

  }

  async btnResend2FA_click() {
    //await this.accountService.resend2FA(this.email);
  }

  async login() {
    if (this.email.trim() == "" || this.password.trim() == "") {
      this.notificationBox.showMessage("Please enter your email and password");
      return;
    }

    try {
      const response = await this.accountService.signin(this.email, this.password);

      if (response.requires2FA) {
        //this.require2FA = true;
        this.pageMode = 'require2FA';
        this.userId = response.userId;
      } 
      else {
        this.returnUserToApp(response);
      }

    } catch (error) {
      console.error("error: ", error);
      //this.showError("Either your email address or password is incorrect.");
      this.notificationBox.showMessage("Either your email address or password is incorrect.");
    }
  }


  async btn2FA_click() {
    if (this.twoFactorCode.trim() != "") {
      await this.accountService.signIn2FA(this.twoFactorCode, this.userId)
      .then((response: any) => {
        this.returnUserToApp(response);
      });
    }
  }

  async resetPassword_click() {
    this.pageMode = 'resetPassword';
    this.cdr.detectChanges();

  }

  async doResetPassword_click() {
    await this.accountService.firebaseResetPassword(this.email)
    .then((response: any) => {
      console.log("response: ", response);
      this.pageMode = 'signIn';
    })
    .catch((error: any) => {
      console.error("error: ", error);
    });
  }

  returnUserToApp(response: any) {

    // if (document.referrer.includes("suite")) {
    //   window.location.href = response.redirectUrl;
    // }
    // else 
    if (response.redirectUrl) {
      window.location.href = response.redirectUrl + "/bootstrap";
    }
    else {
      window.location.href = document.referrer + "/bootstrap";
    }

  }


  // showError(message: string) {
  //   this.uiError = message;
  //   this.errorPop = false;
  

  //   this.errorAnimation = 'none';

  //   setTimeout(() => {
  //     this.errorAnimation = 'error-pop 300ms ease-out';
  //   }, 0);

  //   // requestAnimationFrame(() => {
  //   //   console.log("requestAnimationFrame");
  //   //   this.errorPop = true;
  //   // });
  // }

}
